/**
 * Panel "Acciones Rápidas" del Inicio (réplica del SSR).
 *
 * Presentacional: los accesos directos llegan de `useQuickActions` (derivados de
 * `useNavSections`, ya filtrados por sesión), y se pintan como una lista vertical
 * de botones a ancho completo (equivalente al `d-grid gap-2` del SSR). "Nueva
 * orden" es el botón destacado en azul sólido; el resto, secundarios. La etiqueta
 * de cada botón es el `label` del `NavItem` (única fuente de verdad, coherente con
 * el sidebar). Navega con el patrón canónico `Button asChild` + `<Link>`.
 */
import { Link } from "react-router-dom";

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui";

import { FEATURED_QUICK_ACTION_ID, useQuickActions } from "../hooks/useQuickActions";

export function QuickActions() {
  const actions = useQuickActions();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <i className="fas fa-bolt text-brand" aria-hidden="true" />
          Acciones Rápidas
        </CardTitle>
      </CardHeader>
      <CardContent>
        {actions.length === 0 ? (
          <p className="text-sm text-slate-500">No hay acciones disponibles.</p>
        ) : (
          <div className="flex flex-col gap-2">
            {actions.map((item) => (
              <Button
                key={item.id}
                asChild
                size="md"
                variant={
                  item.id === FEATURED_QUICK_ACTION_ID ? "primary" : "secondary"
                }
                className="w-full"
              >
                <Link to={item.to}>
                  {item.icon && (
                    <i className={item.icon} aria-hidden="true" />
                  )}
                  {item.label}
                </Link>
              </Button>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
